export default function Footer() {
  const userDetails = localStorage.getItem("userDetails");

  if (userDetails) {
    return (
      <div className="az-footer mg-t-5">
        <div className="container">
          <span>Fatores AI - Simplificando o mercado.</span>
          <span>&copy; Fatores AI. Todos os direitos reservados.</span>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
}
